export default "__VITE_ASSET__Bpw5DSpV__"